import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { RootState } from "@/reducers/types";
import { OtherObjectItem } from "@/sx-layout/components/plotmap/components/objectList/models";
import { KeepOutAreaPolygon, KeepOutAreaRectangle } from "@/sx-layout/components/plotmap/models";
import { Mark, MarkType } from "@/sx-layout/models";

export const useOtherObjectList = () => {
  const { t } = useTranslation();

  const areasRectangle = useSelector<RootState, KeepOutAreaRectangle[]>((state) => state.plotmap.keepOutAreas);
  const areasPolygon = useSelector<RootState, KeepOutAreaPolygon[]>((state) => state.plotmap.keepOutAreasPolygon);
  const marks = useSelector<RootState, Mark[]>((state) => state.plotmap.marks);

  const otherObjects = useMemo<OtherObjectItem[]>(() => {
    const areaRectangleList = areasRectangle
      .filter((area) => !area.machine_id) // 紐づきエリアは表示しない
      .map((area) => ({
        id: area.keepout_area_id,
        item: "areaRectangle",
        label: t("keep_out_area"),
        mark_type_id: undefined,
        work_content: area.work_content,
        use_start_hour: area.use_start_hour,
        use_end_hour: area.use_end_hour,
        company_name: area.company_name,
        charge_user_name: area.charge_user_name,
        phone_number: area.phone_number,
        note: area.note,
      })) as OtherObjectItem[];
    const areaPolygonList = areasPolygon.map((area) => ({
      id: area.keepout_area_id,
      item: "areaPolygon",
      label: t("keep_out_area"),
      mark_type_id: undefined,
      work_content: area.work_content,
      use_start_hour: area.use_start_hour,
      use_end_hour: area.use_end_hour,
      company_name: area.company_name,
      charge_user_name: area.charge_user_name,
      phone_number: area.phone_number,
      note: area.note,
    })) as OtherObjectItem[];
    const markList = marks.map((mark) => ({
      id: mark.mark_id,
      item: "mark",
      label: t(Object.values(MarkType).find((type) => type.id === mark.mark_type_id)?.i18n) + t("mark"),
      mark_type_id: undefined,
      work_content: mark.work_content,
      use_start_hour: mark.use_start_hour,
      use_end_hour: mark.use_end_hour,
      company_name: mark.company_name,
      charge_user_name: mark.charge_user_name,
      phone_number: mark.phone_number,
      note: mark.note,
    })) as OtherObjectItem[];

    return [...areaRectangleList, ...areaPolygonList, ...markList];
  }, [areasRectangle, areasPolygon, marks]);

  return otherObjects;
};
